import { isNull } from 'lodash';

import { PaperModel } from 'src/models/paper';

export const useGetCurrentUserRoleByEntity = <T>(entity: PaperModel<unknown, T> | null) => {
  if (isNull(entity)) return null;

  return entity.myRole;
};
